export const mapBuilding = {
  type: 'FeatureCollection',
  data: {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '1',
          name: 'Kitchen',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90960167, 43.62873096],
            [3.90960657, 43.62873513],
            [3.90956957, 43.62875857],
            [3.90956453, 43.62875445],
            [3.90960167, 43.62873096],
          ],
        },
        id: 1,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '1',
          name: 'Desk',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90955776, 43.62885915],
            [3.9095032, 43.62881526],
            [3.90948859, 43.62882477],
            [3.90954316, 43.62886866],
            [3.90955776, 43.62885915],
          ],
        },
        id: 2,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '1',
          name: 'Desk',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90947171, 43.62887506],
            [3.90949855, 43.62889665],
            [3.90951354, 43.62888722],
            [3.90948694, 43.62886563],
            [3.90947171, 43.62887506],
          ],
        },
        id: 3,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '1',
          name: 'Desk',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90948019, 43.62890597],
            [3.90942821, 43.62886416],
            [3.9094136, 43.62887367],
            [3.90946559, 43.62891548],
            [3.90948019, 43.62890597],
          ],
        },
        id: 4,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '1',
          name: 'Kitchen',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90961766, 43.62874446],
            [3.90960009, 43.62875591],
            [3.90959544, 43.62875217],
            [3.90961311, 43.62874066],
            [3.90961766, 43.62874446],
          ],
        },
        id: 5,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '1',
          name: 'Desk',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90944501, 43.62892888],
            [3.90940599, 43.6288975],
            [3.90939194, 43.62890665],
            [3.90943096, 43.62893804],
            [3.90944501, 43.62892888],
          ],
        },
        id: 6,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '1',
          name: 'Desk',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90952879, 43.62880042],
            [3.90954339, 43.62879091],
            [3.90959763, 43.62883453],
            [3.9095828, 43.62884386],
            [3.90952879, 43.62880042],
          ],
        },
        id: 7,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '1',
          name: 'Kitchen table',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90961675, 43.62880671],
            [3.90957699, 43.62877473],
            [3.9095681, 43.62878053],
            [3.90960785, 43.6288125],
            [3.90961675, 43.62880671],
          ],
        },
        id: 8,
      },
      {
        type: 'Feature',
        properties: {
          name: 'Level 1',
          room: 'office',
          level: '1',
          indoor: 'room',
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [3.90931366, 43.629025],
                [3.90924074, 43.62907077],
                [3.90920169, 43.62903817],
                [3.90922953, 43.6290219],
                [3.90918992, 43.62898911],
                [3.90960185, 43.62872843],
                [3.9096182, 43.62874215],
                [3.90969468, 43.62869363],
                [3.90969388, 43.62869296],
                [3.90980702, 43.62862121],
                [3.90985016, 43.62865741],
                [3.90974285, 43.62872441],
                [3.90976165, 43.62873994],
                [3.90976424, 43.62874189],
                [3.90964559, 43.62881713],
                [3.90964295, 43.62881522],
                [3.9096382, 43.62881177],
                [3.90930719, 43.62901955],
                [3.90931366, 43.629025],
              ],
              [
                [3.90961955, 43.6287949],
                [3.90961675, 43.62879666],
                [3.90963477, 43.62881154],
                [3.90961262, 43.62882545],
                [3.909551, 43.62877447],
                [3.90954984, 43.6287752],
                [3.90961145, 43.62882618],
                [3.90941541, 43.62894924],
                [3.9093599, 43.6289029],
                [3.90935556, 43.62889939],
                [3.9093544, 43.62890012],
                [3.90935867, 43.62890368],
                [3.90932596, 43.62892421],
                [3.9093271, 43.62892516],
                [3.90935973, 43.62890468],
                [3.9094141, 43.62895006],
                [3.90937322, 43.62897572],
                [3.90931994, 43.62892965],
                [3.90932133, 43.62892878],
                [3.9093202, 43.62892783],
                [3.90928354, 43.62895084],
                [3.90928467, 43.62895179],
                [3.90931863, 43.62893048],
                [3.90934341, 43.6289519],
                [3.90930246, 43.62897782],
                [3.90927703, 43.62895659],
                [3.90927891, 43.62895541],
                [3.90927777, 43.62895446],
                [3.90927458, 43.62895646],
                [3.90930678, 43.62898334],
                [3.90930809, 43.62898251],
                [3.9093036, 43.62897877],
                [3.90934452, 43.62895287],
                [3.90937191, 43.62897655],
                [3.9093313, 43.62900203],
                [3.90931387, 43.62898733],
                [3.90931309, 43.62898669],
                [3.90931178, 43.62898751],
                [3.90931255, 43.62898815],
                [3.90930659, 43.62899186],
                [3.90930773, 43.62899281],
                [3.90931366, 43.62898912],
                [3.90932999, 43.62900286],
                [3.90931737, 43.62901078],
                [3.909301, 43.628997],
                [3.90930194, 43.62899642],
                [3.90930081, 43.62899546],
                [3.90929616, 43.62899835],
                [3.90929729, 43.62899931],
                [3.90929983, 43.62899773],
                [3.9093162, 43.62901151],
                [3.90930557, 43.62901819],
                [3.90928916, 43.62900437],
                [3.9092915, 43.62900291],
                [3.90929037, 43.62900196],
                [3.90928803, 43.62900342],
                [3.90927862, 43.6289955],
                [3.909291, 43.62898826],
                [3.90927174, 43.62897297],
                [3.90926991, 43.62897418],
                [3.90928739, 43.62898806],
                [3.9092738, 43.62899601],
                [3.90927536, 43.62899741],
                [3.90927669, 43.62899663],
                [3.90928614, 43.62900459],
                [3.90926162, 43.62901998],
                [3.90926276, 43.62902093],
                [3.90928728, 43.62900554],
                [3.90931017, 43.62902481],
                [3.90926818, 43.62905117],
                [3.90924507, 43.62903204],
                [3.90925418, 43.62902632],
                [3.90925304, 43.62902537],
                [3.90924393, 43.62903109],
                [3.90924327, 43.62903054],
                [3.9092414, 43.62903173],
                [3.90924193, 43.62903216],
                // suite de points pour la "spirale"
                [3.90923123, 43.62903882],
                [3.90923108, 43.62903876],
                [3.90923103, 43.62903875],
                [3.90923098, 43.62903874],
                [3.90923093, 43.62903873],
                [3.90923088, 43.62903872],
                [3.90923083, 43.62903871],
                [3.90923078, 43.62903871],
                [3.90923073, 43.6290387],
                [3.90923068, 43.6290387],
                [3.90923063, 43.6290387],
                [3.90923058, 43.62903869],
                [3.90923053, 43.62903869],
                [3.90923048, 43.62903869],
                [3.90923037, 43.62903869],
                [3.90923026, 43.6290387],
                [3.90923015, 43.62903871],
                [3.90923005, 43.62903872],
                [3.90922994, 43.62903874],
                [3.90922984, 43.62903877],
                [3.90922974, 43.62903879],
                [3.90922964, 43.62903882],
                [3.90922954, 43.62903886],
                [3.90922944, 43.6290389],
                [3.90922935, 43.62903894],
                [3.90922926, 43.62903899],
                [3.90922918, 43.62903904],
                [3.90922909, 43.62903909],
                [3.90922901, 43.62903915],
                [3.90922891, 43.62903924],
                [3.90922881, 43.62903934],
                [3.90922873, 43.62903944],
                [3.90922866, 43.62903954],
                [3.9092286, 43.62903965],
                [3.90922855, 43.62903976],
                [3.90922852, 43.62903987],
                [3.9092285, 43.62903999],
                [3.90922849, 43.6290401],
                [3.90922849, 43.62904022],
                [3.90922851, 43.62904033],
                [3.90922854, 43.62904045],
                [3.90922858, 43.62904056],
                [3.90922863, 43.62904067],
                [3.9092287, 43.62904078],
                [3.90922878, 43.62904087],
                [3.90922886, 43.62904096],
                [3.90922895, 43.62904105],
                [3.90922904, 43.62904113],
                [3.90922915, 43.6290412],
                [3.90922926, 43.62904127],
                [3.90922938, 43.62904133],
                [3.9092295, 43.62904138],
                [3.90922963, 43.62904143],
                [3.90922976, 43.62904147],
                [3.9092299, 43.6290415],
                [3.90923004, 43.62904153],
                [3.90923018, 43.62904155],
                [3.90923032, 43.62904156],
                [3.90923047, 43.62904157],
                [3.90923049, 43.62904157],
                [3.9092305, 43.62904157],
                [3.90923052, 43.62904157],
                [3.90923053, 43.62904157],
                [3.90923055, 43.62904156],
                [3.90923056, 43.62904156],
                [3.90923058, 43.62904156],
                [3.90923059, 43.62904156],
                [3.90923061, 43.62904156],
                [3.90923063, 43.62904156],
                [3.90923064, 43.62904156],
                [3.90923066, 43.62904156],
                [3.90923067, 43.62904156],
                [3.90923069, 43.62904156],
                [3.9092307, 43.62904156],
                [3.90923087, 43.62904154],
                [3.90923103, 43.62904151],
                [3.90923118, 43.62904147],
                [3.90923133, 43.62904143],
                [3.90923147, 43.62904137],
                [3.9092316, 43.62904131],
                [3.90923173, 43.62904124],
                [3.90923185, 43.62904117],
                [3.90923196, 43.62904108],
                [3.90923206, 43.62904099],
                [3.90923215, 43.6290409],
                [3.90923223, 43.6290408],
                [3.9092323, 43.62904069],
                [3.90923236, 43.62904058],
                [3.90923236, 43.62904049],
                [3.90924355, 43.62903355],
                [3.9092663, 43.62905234],
                [3.90924099, 43.62906823],
                [3.90920525, 43.6290384],
                [3.90923116, 43.62902325],
                [3.90923393, 43.62902554],
                [3.9092358, 43.62902436],
                [3.90923309, 43.62902212],
                [3.90926653, 43.62900257],
                [3.90926497, 43.62900117],
                [3.90923146, 43.62902077],
                [3.90919342, 43.62898928],
                [3.90924656, 43.62895565],
                [3.90926226, 43.62896811],
                [3.90926409, 43.6289669],
                [3.90924843, 43.62895447],
                [3.90934572, 43.6288929],
                [3.90934696, 43.62889391],
                [3.90934812, 43.62889318],
                [3.9093469, 43.62889217],
                [3.90954198, 43.6287687],
                [3.90954236, 43.62876902],
                [3.90954352, 43.62876828],
                [3.90954314, 43.62876797],
                [3.9096016, 43.62873097],
                [3.90961796, 43.6287447],
                [3.9096963, 43.62869506],
                [3.90970174, 43.62869955],
                [3.90970362, 43.62869838],
                [3.90969737, 43.62869314],
                [3.90975168, 43.6286587],
                [3.90975643, 43.62866258],
                [3.90975762, 43.62866189],
                [3.90975286, 43.62865794],
                [3.90980677, 43.62862375],
                [3.90984666, 43.62865722],
                [3.90979274, 43.62869089],
                [3.90976504, 43.628668],
                [3.90976388, 43.62866874],
                [3.90979157, 43.62869162],
                [3.90974004, 43.62872379],
                [3.90971466, 43.62870283],
                [3.9097114, 43.62870491],
                [3.90971104, 43.62870461],
                [3.90970916, 43.62870578],
                [3.90971045, 43.62870686],
                [3.90968038, 43.62872564],
                [3.90967659, 43.62872654],
                [3.90966996, 43.62872784],
                [3.90966638, 43.62873136],
                [3.9096655, 43.62873609],
                [3.90966833, 43.62874006],
                [3.90967211, 43.62874216],
                [3.90967603, 43.6287427],
                [3.90968405, 43.62874064],
                [3.90968763, 43.62873708],
                [3.90968703, 43.62873173],
                [3.90968396, 43.62872816],
                [3.90968138, 43.62872648],
                [3.90971145, 43.62870771],
                [3.90973487, 43.62872702],
                [3.90973933, 43.62872423],
                [3.90975979, 43.62874113],
                [3.90969764, 43.62878054],
                [3.90966425, 43.62875252],
                [3.90965201, 43.62874391],
                [3.90963574, 43.62875404],
                [3.9096368, 43.62875481],
                [3.90965195, 43.62874542],
                [3.90966313, 43.62875329],
                [3.90969648, 43.62878128],
                [3.90964483, 43.62881403],
                [3.90963832, 43.62880931],
                [3.90963758, 43.62880978],
                [3.90962376, 43.62879837],
                [3.9096284, 43.62879538],
                [3.90962417, 43.62879185],
                [3.90961955, 43.6287949],
              ],
            ],
          ],
        },
        id: 1,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          name: 'Foot',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90959159, 43.62852208],
            [3.90973183, 43.62863961],
            [3.90999282, 43.62847645],
            [3.90985259, 43.62835892],
            [3.90959159, 43.62852208],
          ],
        },
        id: 1,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          name: 'Urban soccer',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90970856, 43.62888641],
            [3.90985392, 43.62879379],
            [3.90975914, 43.62871501],
            [3.91008062, 43.62851157],
            [3.90966935, 43.62816925],
            [3.90854574, 43.62888143],
            [3.90895494, 43.62922288],
            [3.90917941, 43.62908095],
            [3.90919953, 43.62909766],
            [3.90931641, 43.62902455],
            [3.90930723, 43.62901664],
            [3.90929571, 43.6290075],
            [3.90937176, 43.62895857],
            [3.90961326, 43.62880708],
            [3.90970856, 43.62888641],
          ],
        },
        id: 2,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          room: 'office',
          name: 'Padel',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90937932, 43.62848808],
            [3.90955608, 43.62837698],
            [3.90946926, 43.6283046],
            [3.90929249, 43.62841569],
            [3.90937932, 43.62848808],
          ],
        },
        id: 3,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          name: 'Foot',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90878974, 43.62905011],
            [3.90892997, 43.62916763],
            [3.90919096, 43.62900448],
            [3.90905073, 43.62888695],
            [3.90878974, 43.62905011],
          ],
        },
        id: 4,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          room: 'office',
          name: 'Padel',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.9094767, 43.62856911],
            [3.90965346, 43.62845802],
            [3.90956664, 43.62838564],
            [3.90938987, 43.62849673],
            [3.9094767, 43.62856911],
          ],
        },
        id: 5,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          room: 'office',
          name: 'Padel',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90929412, 43.62868353],
            [3.90947088, 43.62857243],
            [3.90938405, 43.62850005],
            [3.90920729, 43.62861115],
            [3.90929412, 43.62868353],
          ],
        },
        id: 6,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          room: 'office',
          name: 'Padel',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90965988, 43.62845406],
            [3.90983664, 43.62834297],
            [3.90974981, 43.62827058],
            [3.90957305, 43.62838168],
            [3.90965988, 43.62845406],
          ],
        },
        id: 7,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          name: 'Foot',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.9090584, 43.62888156],
            [3.90919863, 43.62899909],
            [3.90945963, 43.62883593],
            [3.90931939, 43.6287184],
            [3.9090584, 43.62888156],
          ],
        },
        id: 8,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          name: 'Entrée / espace ludique',
          amenity: 'entertainment',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90970059, 43.62866771],
            [3.90972432, 43.6286865],
            [3.90975914, 43.62871501],
            [3.90972029, 43.62873934],
            [3.90963476, 43.6287934],
            [3.90961326, 43.62880708],
            [3.90955391, 43.62875997],
            [3.90970059, 43.62866771],
          ],
        },
        id: 9,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          name: 'Foot',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90885017, 43.62871179],
            [3.9089904, 43.62882932],
            [3.90925139, 43.62866616],
            [3.90911116, 43.62854863],
            [3.90885017, 43.62871179],
          ],
        },
        id: 10,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          room: 'office',
          name: 'Padel',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90919667, 43.62860279],
            [3.90937343, 43.62849169],
            [3.90928661, 43.62841931],
            [3.90910984, 43.62853041],
            [3.90919667, 43.62860279],
          ],
        },
        id: 11,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          room: 'office',
          name: 'Padel',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90961326, 43.62880708],
            [3.90970853, 43.62888641],
            [3.90985391, 43.6287938],
            [3.90975916, 43.62871501],
            [3.90961326, 43.62880708],
          ],
        },
        id: 12,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          room: 'office',
          name: 'Padel',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90956298, 43.62837312],
            [3.90973974, 43.62826202],
            [3.90965292, 43.62818964],
            [3.90947615, 43.62830073],
            [3.90956298, 43.62837312],
          ],
        },
        id: 13,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          name: 'Foot',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90858218, 43.6288796],
            [3.90872241, 43.62899712],
            [3.9089834, 43.62883396],
            [3.90884317, 43.62871644],
            [3.90858218, 43.6288796],
          ],
        },
        id: 14,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '0',
          room: 'office',
          name: 'Foot',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90932161, 43.62869135],
            [3.90946184, 43.62880888],
            [3.90972283, 43.62864572],
            [3.9095826, 43.62852819],
            [3.90932161, 43.62869135],
          ],
        },
        id: 15,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '2',
          name: 'Roof',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.90970856, 43.62888641],
            [3.90985392, 43.62879379],
            [3.90975914, 43.62871501],
            [3.91008062, 43.62851157],
            [3.90966935, 43.62816925],
            [3.90854574, 43.62888143],
            [3.90895494, 43.62922288],
            [3.90917941, 43.62908095],
            [3.90919953, 43.62909766],
            [3.90931641, 43.62902455],
            [3.90930723, 43.62901664],
            [3.90929571, 43.6290075],
            [3.90937176, 43.62895857],
            [3.90961326, 43.62880708],
            [3.90970856, 43.62888641],
          ],
        },
        id: 16,
      },
      {
        type: 'Feature',
        properties: {
          indoor: 'room',
          level: '1',
          name: 'Roof',
          room: 'office',
        },
        geometry: {
          type: 'LineString',
          coordinates: [
            [3.9096273, 43.62881899],
            [3.90970852, 43.62888642],
            [3.90985303, 43.62879372],
            [3.90975911, 43.62871503],
            [3.91008058, 43.62851159],
            [3.90966931, 43.62816926],
            [3.9085457, 43.62888145],
            [3.9089549, 43.6292229],
            [3.90917937, 43.62908096],
            [3.90919949, 43.62909768],
            [3.90931638, 43.62902457],
            [3.90931306, 43.62902151],
            [3.90930925, 43.62901829],
          ],
        },
        id: 1,
      },
    ],
  },
};
